import React, { useState, useEffect } from 'react';
import { getInstaTokenApi, updateInstaTokenApi } from 'Services/allApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdEdit } from "react-icons/md";

const InstaToken = () => {
    const [tokenData, setTokenData] = useState({ id: null, token: '' });
    const [loading, setLoading] = useState(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editToken, setEditToken] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const fetchTokenData = async () => {
            try {
                const response = await getInstaTokenApi();
                if (response.error) {
                    console.error("Error fetching token data:", response.message);
                    toast.error("Error fetching token data");
                } else {
                    setTokenData(response.data);
                }
            } catch (error) {
                console.error("Error fetching token:", error);
                toast.error("Error fetching token");
            } finally {
                setLoading(false);
            }
        };

        fetchTokenData();
    }, []);

    const handleEditTokenChange = (e) => {
        setEditToken(e.target.value);
        setErrorMessage('');
    };

    const handleEditToken = async () => {
        if (!editToken) {
            setErrorMessage('Token cannot be empty');
            toast.error('Token cannot be empty');
            return;
        }

        try {
            const response = await updateInstaTokenApi(tokenData.id, { token: editToken });
            if (response.error) {
                console.error("Error updating token:", response.message);
                toast.error("Error updating token");
            } else {
                setTokenData({ ...tokenData, token: editToken });
                setShowEditModal(false);
                toast.success("Token updated successfully");
            }
        } catch (error) {
            console.error("Error updating token:", error);
            toast.error("Error updating token");
        }
    };

    return (
        <div className="w-full max-w-6xl mx-auto p-8 bg-white shadow-lg rounded-lg dark:!bg-navy-700 dark:text-white">
            <h2 className="text-4xl font-semibold mb-6">Instagram Token</h2>

            {loading ? (
                <div className="text-center">
                    <p className="text-lg text-purple-800">Loading...</p>
                </div>
            ) : (
                <div className="p-6 border border-gray-200 rounded-lg shadow-md dark:border-gray-600 dark:bg-[#0b14374d]">
                    <h3 className="text-xl font-bold mb-4">Token</h3>
                    <p className="w-full px-4 py-2 border rounded-lg bg-gray-100 dark:bg-[#0b14374d] break-all">
                        {tokenData.token}
                    </p>
                    <div className="flex justify-end mt-4">
                        <button
                            onClick={() => {
                                setEditToken(tokenData.token);
                                setShowEditModal(true);
                            }}
                            className="rounded-md border-2 border-yellow-600 px-3 py-2 font-semibold text-yellow-600 shadow-sm hover:bg-yellow-100 flex items-center"
                        >
                            <MdEdit className="mr-2" /> Edit
                        </button>
                    </div>
                </div>
            )}

            {showEditModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-xl w-1/2 dark:bg-gray-800 dark:text-white">
                        <h3 className="text-2xl font-bold mb-4">Edit Token</h3>
                        <textarea
                            rows="4"
                            name="token"
                            placeholder="Enter new token"
                            value={editToken}
                            onChange={handleEditTokenChange}
                            className="w-full px-4 py-2 border rounded-lg mb-4 dark:bg-[#0b14374d] dark:border-gray-600 dark:text-white"
                        />
                        {errorMessage && (
                            <p className="text-red-600 text-sm m-2">{errorMessage}</p>
                        )}
                        <div className="flex justify-between">
                            <button
                                onClick={() => setShowEditModal(false)}
                                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleEditToken}
                                className="bg-purple-600 text-white px-4 py-2 rounded-md"
                            >
                                Update Token
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
        </div>
    );
};

export default InstaToken;
